import { usePullCpoLocationsMutation } from 'src/core/service/location.service';
import { useApiError } from 'src/core/helper/use-api-error';

export function usePullCpoLocations(cpoId: string): {
  handleFetch: () => void;
  isLoading: boolean;
  isError: boolean;
  status: number | null;
  message: string | null;
} {
  const [triggerPullCpoLocations, { isLoading, error, isError }] =
    usePullCpoLocationsMutation();

  const { status, message } = useApiError(error);

  const handleFetch = () => {
    if (cpoId) {
      triggerPullCpoLocations({ cpoId });
    }
  };

  return {
    handleFetch,
    isLoading,
    isError,
    status,
    message,
  };
}
